import Button from 'components/common/Button/Button';
import ELEMENT from 'common/element';
import { Parser, ParserType } from 'common/graphqlTypes';
import LogsView from './Logs/Logs';
import { PARSER_TYPES } from './consts';
import { RowObject } from './types';
import './styles.scss';

type RowDataParam = Parser & {
  isWriteDisabled: boolean;
  onRevertChanges: (parser: string) => void;
  onCreateCustomParser: (parser: string) => void;
  onModifyParser: (parser: string) => void;
};

export const makeParserRowData = ({
  id,
  name,
  type,
  logCount,
  logs,
  isWriteDisabled,
  onRevertChanges,
  onCreateCustomParser,
  onModifyParser,
}: RowDataParam): RowObject => ({
  id,
  name,
  typeValue: type,
  type: (
    <span className={type === ParserType.UNDEFINED ? 'ParsersPage__UndefinedParser' : ''}>
      {PARSER_TYPES[type].name}
    </span>
  ),
  logCount,
  logs: <LogsView logs={logs} logCount={logCount} />,
  actions: (
    <div className="ParsersPage__Actions">
      {type === ParserType.UNDEFINED && (
        <Button
          size="sm"
          className="ParsersPage__ActionButton"
          onClick={(): void => {
            onModifyParser(id);
          }}
          testId={ELEMENT.createParserButton}
        >
          {isWriteDisabled ? 'View' : 'Create'}
        </Button>
      )}
      {(type === ParserType.CUSTOM || type === ParserType.BUILT_IN || type === ParserType.BUILT_IN_CUSTOM) && (
        <Button
          size="sm"
          className="ParsersPage__ActionButton"
          onClick={(): void => {
            onModifyParser(id);
          }}
        >
          {isWriteDisabled ? 'View' : 'Edit'}
        </Button>
      )}
      <Button
        size="sm"
        className="ParsersPage__ActionButton ParsersPage__CreateButton"
        onClick={(): void => {
          onCreateCustomParser(id);
        }}
        testId={ELEMENT.createParserRequestButton}
      >
        {type !== ParserType.UNDEFINED ? 'Ask us to edit for you' : 'Ask us to create for you'}
      </Button>
      {type === ParserType.BUILT_IN_CUSTOM && (
        <Button
          size="sm"
          className="ParsersPage__ActionButton ParsersPage__RevertButton"
          onClick={(): void => onRevertChanges(id)}
        >
          Revert
        </Button>
      )}
    </div>
  ),
});
